import {lazy} from 'react';

export const ProfileFindFriendsAsync = lazy(() =>
    import('./ProfileFindFriends')
);
